import React from 'react';

interface SatsumaLogoProps {
  size?: number;
  className?: string;
}

const SatsumaLogo: React.FC<SatsumaLogoProps> = ({ size = 24, className = '' }) => {
  return (
    <img
      src="/logo.png"
      alt="Satsuma"
      width={size}
      height={size}
      className={className}
    />
  );
};

export default SatsumaLogo;
